import { render, staticRenderFns } from "./ObjectiveCard.vue?vue&type=template&id=2ac4fcc4&scoped=true"
import script from "./ObjectiveCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ObjectiveCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ObjectiveCard.vue?vue&type=style&index=0&id=2ac4fcc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4fcc4",
  null
  
)

export default component.exports